import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'aw-client-eula-dialog',
  templateUrl: './client-eula-dialog.component.html',
  styleUrls: ['./client-eula-dialog.component.scss']
})
export class ClientEulaDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
